(function() {

	var themes = [
		{
			sku: 'TRX-THM-000',
			name: 'Standard',
			class: 'theme-standard'
		},
		{
			sku: 'TRX-THM-004',
			name: 'Baby',
			class: 'theme-baby'
		},
		{
			sku: 'TRX-THM-017',
			name: 'Blue Streaks',
			class: 'theme-blue-streaks'
		},
		{
			sku: 'TRX-THM-016',
			name: 'Blur',
			class: 'theme-blur'
		},
		{
			sku: 'TRX-THM-005',
			name: 'Celebration',
			class: 'theme-celebration'
		},
		{
			sku: 'TRX-THM-006',
			name: 'Children',
			class: 'theme-children'
		},
		{
			sku: 'TRX-THM-022',
			name: 'Christmas',
			class: 'theme-christmas'
		},
		{
			sku: 'TRX-THM-027',
			name: 'Dog',
			class: 'theme-dog'
		},
		{
			sku: 'TRX-THM-018',
			name: 'Family History',
			class: 'theme-family-history'
		},
		{
			sku: 'TRX-THM-007',
			name: 'Inspirations',
			class: 'theme-inspirations'
		},
		{
			sku: 'TRX-THM-019',
			name: 'Movie Night',
			class: 'theme-movie-night'
		},
		{
			sku: 'TRX-THM-020',
			name: 'Movie Stars',
			class: 'theme-movie-stars'
		},
		{
			sku: 'TRX-THM-009',
			name: 'Paradise',
			class: 'theme-paradise'
		},
		{
			sku: 'TRX-THM-021',
			name: 'Scrapbook',
			class: 'theme-scrapbook'
		},
		{
			sku: 'TRX-THM-008',
			name: 'Wedding',
			class: 'theme-wedding'
		},
		{
			sku: 'TRX-THM-023',
			name: 'Winter Snow',
			class: 'theme-winter-snow'
		}
	];

	var music = [
		{
			sku: 'MIS-BMU-NOM',
			name: 'No Music',
			class: 'music-no-music',
			preview: ''
		},
		{
			sku: 'MIS-BMU-BBY',
			name: 'Baby',
			class: 'music-baby',
			preview: 'https://d1rbse7yst4ks0.cloudfront.net/catalog/MIS-BMU-BBY/music-sm.mp3'
		},
		{
			sku: 'MIS-BMU-BBA',
			name: 'Big Band',
			class: 'music-big-band',
			preview: 'https://d1rbse7yst4ks0.cloudfront.net/catalog/MIS-BMU-BBA/music-sm.mp3'
		},
		{
			sku: 'MIS-BMU-CEL',
			name: 'Celebration',
			class: 'music-celebration',
			preview: 'https://d1rbse7yst4ks0.cloudfront.net/catalog/MIS-BMU-CEL/music-sm.mp3'
		},
		{
			sku: 'MIS-BMU-CHD',
			name: 'Children',
			class: 'music-children',
			preview: 'https://d1rbse7yst4ks0.cloudfront.net/catalog/MIS-BMU-CHD/music-sm.mp3'
		},
		{
			sku: 'MIS-BMU-CLA',
			name: 'Classical',
			class: 'music-classical',
			preview: 'https://d1rbse7yst4ks0.cloudfront.net/catalog/MIS-BMU-CLA/music-sm.mp3'
		},
		{
			sku: 'MIS-BMU-COU',
			name: 'Country',
			class: 'music-country',
			preview: 'https://d1rbse7yst4ks0.cloudfront.net/catalog/MIS-BMU-COU/music-sm.mp3'
		},
		{
			sku: 'MIS-BMU-ROC',
			name: 'Rock N Roll',
			class: 'music-rock-n-roll',
			preview: 'https://d1rbse7yst4ks0.cloudfront.net/catalog/MIS-BMU-ROC/music-sm.mp3'
		},
		{
			sku: 'MIS-BMU-JAZ',
			name: 'Smooth Jazz',
			class: 'music-smooth-jazz',
			preview: 'https://d1rbse7yst4ks0.cloudfront.net/catalog/MIS-BMU-JAZ/music-sm.mp3'
		},
		{
			sku: 'MIS-BMU-HAW',
			name: 'Tropical Paradise',
			class: 'music-paradise',
			preview: 'https://d1rbse7yst4ks0.cloudfront.net/catalog/MIS-BMU-HAW/music-sm.mp3'
		},
		{
			sku: 'MIS-BMU-WED',
			name: 'Wedding',
			class: 'music-wedding',
			preview: 'https://d1rbse7yst4ks0.cloudfront.net/catalog/MIS-BMU-WED/music-sm.mp3'
		},
		{
			sku: 'MIS-BMU-WHD',
			name: 'Winter Holiday',
			class: 'music-winter-holiday',
			preview: 'https://d1rbse7yst4ks0.cloudfront.net/catalog/MIS-BMU-WHD/music-sm.mp3'
		}
	];

	let selectedTheme;
	let selectedThemeTitle;
	let selectedMusic;
	let selectedMusicTitle;
	let originalAudioEnabled = false;

	if( window.location.search.indexOf( '?edit=' ) >= 0 ) {

		setTimeout( function() {

			selectedTheme = $( '.input-dvd-off-canvas-customizer-inner-theme-image' ).attr( 'class' ).split( 'my-5 mx-auto relative max-w-[350px] bg-contain bg-center bg-no-repeat before:w-full before:pt-[70%] before:block input-dvd-off-canvas-customizer-inner-theme-image ' )[ 1 ];
			selectedThemeTitle = $( '.input-dvd-extra-theme-title' ).html();
			selectedMusic = 'music-no-music';

			$.each( music, function( index, values ) {

				if( values.name === $( '.input-dvd-extra-music-title' ).html() ) {

					selectedMusic = values.class

				}

			});

			if( $( '.input-original-audio-details' ).prop( 'checked' ) === true ) {

				selectedMusicTitle = $( '.input-dvd-extra-music-title' ).html();
				$( '.input-dvd-extra-music-title' ).html( 'Original Audio' );

			} else {

				selectedMusicTitle = $( '.input-dvd-extra-music-title' ).html();

			}

		}, 2000 );

	} else {

		selectedTheme = 'theme-standard';
		selectedThemeTitle = 'Standard';
		selectedMusic = 'music-no-music';
		selectedMusicTitle = 'No Music';

	}

	if( $( '#dvd-quantity' ).length > 0 ) {

		if( $( '.input-dvd-off-canvas-customizer-inner-theme-options-inner' ).length > 0 ) {

			$.each( themes, function( index, values ) {

				if( index === 0 ) {

					$( '.input-dvd-off-canvas-customizer-inner-theme-options-inner' ).append(
						'<div class="theme-option-radio">' +
						'<input type="radio" aria-label="Theme option: ' +  values.name + '" checked="checked" name="properties[dvd][theme]" value="' + values.sku + '" id="' + values.class + '" />' +
						'<label for="' + values.class + '" class="theme-label ' + values.class + '">' +
						'<span>' + values.name + '</span>' +
						'</label>' +
						'</div>'
					);

				} else {

					$( '.input-dvd-off-canvas-customizer-inner-theme-options-inner' ).append(
						'<div class="theme-option-radio">' +
						'<input type="radio" aria-label="Theme option: ' +  values.name + '" name="properties[dvd][theme]" value="' + values.sku + '" id="' + values.class + '" />' +
						'<label for="' + values.class + '" class="theme-label ' + values.class + '">' +
						'<span>' + values.name + '</span>' +
						'</label>' +
						'</div>'
					);

				}

			});

		}

		if( $( '.input-dvd-off-canvas-customizer-inner-music-container' ).length > 0 ) {

			$.each( music, function( index, values ) {

				if( index == 0 ) {

					$( '.input-dvd-off-canvas-customizer-inner-music-options-inner' ).append(
						'<div class="music-option-radio-wrapper">' +
						'<span class="audio-pause-icon" tabindex="0" aria-label="Pause Music"><svg width="26" height="24" xmlns="http://www.w3.org/2000/svg"><g fill="#ffffff" fill-rule="evenodd"><path d="M7 3h3v18H7zM16 3h3v18h-3z"/></g></svg></span>' +
						'<div class="music-option-radio">' +
						'<input type="radio" aria-label="Music option: ' +  values.name + '" checked="checked" name="properties[dvd][music]" value="' + values.sku + '" id="' + values.class + '" />' +
						'<audio src="' + values.preview + '"></audio>' +
						'<label for="' + values.class + '" class="' + values.class +'">' +
						'<span>' + values.name + '</span>' +
						'</label>' +
						'</div>' +
						'</div>'
					);

				} else {

					$( '.input-dvd-off-canvas-customizer-inner-music-options-inner' ).append(
						'<div class="music-option-radio-wrapper">' +
						'<span class="audio-pause-icon" tabindex="0" aria-label="Pause Music"><svg width="26" height="24" xmlns="http://www.w3.org/2000/svg"><g fill="#ffffff" fill-rule="evenodd"><path d="M7 3h3v18H7zM16 3h3v18h-3z"/></g></svg></span>' +
						'<div class="music-option-radio">' +
						'<input type="radio" aria-label="Music option: ' +  values.name + '" name="properties[dvd][music]" value="' + values.sku + '" id="' + values.class + '" />' +
						'<audio src="' + values.preview + '"></audio>' +
						'<label for="' + values.class + '" class="' + values.class +'">' +
						'<span>' + values.name + '</span>' +
						'</label>' +
						'</div>' +
						'</div>'
					);

				}

			});

		}

	}

	$( '.theme-option-radio' ).on( 'click', function() {

		$( '.theme-option-radio' ).each( function() {

			$( this ).find( 'input' ).prop( 'checked', false );

		});

		const newBackgroundProperty = $( this ).find( 'label' ).attr( 'class' ).split( /\s+/ );
		const newBackgroundClass = newBackgroundProperty[ 1 ];

		$( '.input-dvd-off-canvas-customizer-inner-theme-image' ).attr( 'class', 'my-5 mx-auto relative max-w-[350px] bg-contain bg-center bg-no-repeat before:w-full before:pt-[70%] before:block input-dvd-off-canvas-customizer-inner-theme-image ' + newBackgroundClass );

		$( this ).find( 'input' ).prop( 'checked', true );

		const title = $( this ).find( 'span' );

		$( '.input-dvd-extra-theme-title' ).html( $( title ).html() );

	});

	$( '.music-option-radio' ).on( 'click', function() {

		if( $( '#input-audio-checkbox' ).is( ':checked' ) ) {
			return;
		}

		$( '.music-option-radio' ).each( function() {

			$( this ).find( 'input' ).prop( 'checked', false );

		});

		$( this ).find( 'input' ).prop( 'checked', true );


		$( 'audio' ).each( function() {

			this.pause();

		})

		const audio = $( this ).find( 'audio' );

		audio[ 0 ].play();

		$( '.audio-pause-icon' ).each( function() {

			$( this ).removeClass( 'active' );

		})

		const pauseIcon = $( this ).parent().find( '.audio-pause-icon' );

		$( pauseIcon ).addClass( 'active' );

		const title = $( this ).find( 'span' );

		$( '.input-dvd-extra-music-title' ).html( $( title ).html() );

	});

	$( '.audio-pause-icon' ).each( function() {

		$( this ).on( 'click', function() {

			$( 'audio' ).each( function() {

				this.pause();

			});

			$( '.audio-pause-icon' ).each( function() {

				$( this ).removeClass( 'active' );

			})

		});

	});

	$( '.js-save-dvd' ).on( 'click', function() {

		$( 'input[name="properties[dvd][theme]"]' ).each( function() {

			if( $( this ).is( ':checked' ) ) {

				selectedTheme = $( this ).attr( 'id' );

			}

		});

		selectedThemeTitle = $( '.input-dvd-extra-theme-title' ).html();

		$( 'input[name="properties[dvd][music]"]' ).each( function() {

			if( $( this ).is( ':checked' ) ) {

				selectedMusic = $( this ).attr( 'id' );

			}

		});

		if( !originalAudioEnabled ) {

			selectedMusicTitle = $( '.input-dvd-extra-music-title' ).html();

		}

	});

	$( '.js-cancel-dvd' ).on( 'click', function() {

		$( 'input[name="properties[dvd][theme]"]' ).each( function() {

			if( $( this ).attr( 'id' ) == selectedTheme ) {

				$( this ).prop( 'checked', true );

				$( '.input-dvd-off-canvas-customizer-inner-theme-image' ).attr( 'class', 'my-5 mx-auto relative max-w-[350px] bg-contain bg-center bg-no-repeat before:w-full before:pt-[70%] before:block input-dvd-off-canvas-customizer-inner-theme-image ' + $( this ).attr( 'id' ) );

			} else {

				$( this ).prop( 'checked', false );

			}

		});

		$( '.input-dvd-extra-theme-title' ).html( selectedThemeTitle);

		$( 'input[name="properties[dvd][music]"]' ).each( function() {

			if( $( this ).attr( 'id' ) == selectedMusic ) {

				$( this ).prop( 'checked', true );

			} else {

				$( this ).prop( 'checked', false );

			}
		});

		if( !originalAudioEnabled ) {

			$( '.input-dvd-extra-music-title' ).html( selectedMusicTitle );

		}

		$( '.input-dvd-off-canvas-customizer-inner-theme-options-inner' ).scrollLeft( 0 );
		$( '.input-dvd-off-canvas-customizer-inner-music-options-inner' ).scrollLeft( 0 );

	});

	$( document ).on( 'click', '#input-audio-checkbox', function( e ) {

		if( $( this ).is( ':checked' ) ) {

			$( '.music-option-radio-wrapper' ).each( function() {

				$( this ).addClass( 'disabled' );

			});

			$( ".input-audio-message" ).removeClass( 'hidden' );

			$( ".drawer-input-audio-message" ).html( "Music is unavailable with Original Audio." );

			$( ".drawer-input-audio-message" ).css( "font-size", "14px" );

			$( '.input-dvd-extra-music-title' ).html( 'Original Audio' );

			originalAudioEnabled = true;

		} else {

			$( '.music-option-radio-wrapper' ).each( function() {

				$( this ).removeClass( 'disabled' );

			});

			$( ".input-audio-message" ).addClass( 'hidden' );

			$( ".drawer-input-audio-message" ).html( "If original audio is selected, music cannot be added to DVD Customizations." );

			$( ".drawer-input-audio-message" ).css( "font-size", "12px" );

			$( '.input-dvd-extra-music-title' ).html( selectedMusicTitle );

			originalAudioEnabled = false;

		}

	});

	$( '.dvd-customize-scroll-theme' ).on( 'click', function () {

		var currentScroll = $( '.input-dvd-off-canvas-customizer-inner-theme-options-inner' ).scrollLeft();
		var newScroll = currentScroll + 500;
		var maxScroll = $( '.input-dvd-off-canvas-customizer-inner-theme-options-inner' )[ 0 ].scrollWidth - $( '.input-dvd-off-canvas-customizer-inner-theme-options-inner' )[ 0 ].clientWidth;

		$( '.input-dvd-off-canvas-customizer-inner-theme-options-inner' )[ 0 ].scrollTo({
			top: 0,
			left: newScroll,
			behavior: 'smooth'
		});

		if( newScroll > ( maxScroll - 100 ) ) {

			$( this ).hide();

		}

	});

	$( '.scroll-previous-theme' ).on( 'click', function () {

		var currentScroll = $( '.input-dvd-off-canvas-customizer-inner-theme-options-inner' ).scrollLeft();
		var newScroll = currentScroll - 500;
		var maxScroll = $( '.input-dvd-off-canvas-customizer-inner-theme-options-inner' )[ 0 ].scrollWidth - $( '.input-dvd-off-canvas-customizer-inner-theme-options-inner' )[ 0 ].clientWidth;

		$( '.input-dvd-off-canvas-customizer-inner-theme-options-inner' )[ 0 ].scrollTo({
			top: 0,
			left: newScroll,
			behavior: 'smooth'
		});

		if( newScroll < 0 ) {

			$( this ).hide();
			$( '.input-dvd-off-canvas-customizer-inner-theme-options-inner' ).removeClass( 'showBefore' );

		}

	});

	$( '.input-dvd-off-canvas-customizer-inner-theme-options-inner' ).on( 'scroll', function() {

		var currentScroll = $( this ).scrollLeft();
		var maxScroll = $( '.input-dvd-off-canvas-customizer-inner-theme-options-inner' )[ 0 ].scrollWidth - $( '.input-dvd-off-canvas-customizer-inner-theme-options-inner' )[ 0 ].clientWidth;

		if( currentScroll < maxScroll ) {

			$( '.dvd-customize-scroll-theme' ).show();

		} else {

			$( '.dvd-customize-scroll-theme' ).hide();

		}

		if( currentScroll > 0 ) {

			$( '.input-dvd-off-canvas-customizer-inner-theme-options' ).addClass( 'show-before' );
			$( '.scroll-previous-theme' ).removeClass( 'hidden' );

		} else {

			$( '.input-dvd-off-canvas-customizer-inner-theme-options' ).removeClass( 'show-before' );
			$( '.scroll-previous-theme' ).addClass( 'hidden' );

		}

	});

	$( '.dvd-customize-scroll-music' ).on( 'click', function () {

		var currentScroll = $( '.input-dvd-off-canvas-customizer-inner-music-options-inner' ).scrollLeft();
		var newScroll = currentScroll + 500;
		var maxScroll = $( '.input-dvd-off-canvas-customizer-inner-music-options-inner' )[ 0 ].scrollWidth - $( '.input-dvd-off-canvas-customizer-inner-music-options-inner' )[ 0 ].clientWidth;

		$( '.input-dvd-off-canvas-customizer-inner-music-options-inner' )[ 0 ].scrollTo({
			top: 0,
			left: newScroll,
			behavior: 'smooth'
		});

		if( newScroll > maxScroll ) {

			$( this ).hide();

		}

		if( newScroll < 0 ) {

			$( this ).hide();
			$( '.input-dvd-off-canvas-customizer-inner-music-options-inner' ).removeClass( 'showBefore' );

		}

	});

	$( '.scroll-previous-music' ).on( 'click', function() {

		var currentScroll = $( '.input-dvd-off-canvas-customizer-inner-music-options-inner' ).scrollLeft();
		var newScroll = currentScroll - 500;

		$( '.input-dvd-off-canvas-customizer-inner-music-options-inner' )[ 0 ].scrollTo({
			top: 0,
			left: newScroll,
			behavior: 'smooth'
		});

		if( newScroll < 0 ) {

			$( this ).removeClass( 'active' );
			$( '.input-dvd-off-canvas-customizer-inner-music-options-inner' ).removeClass( 'showBefore' );

		}

	});

	$( '.input-dvd-off-canvas-customizer-inner-music-options-inner' ).on( 'scroll', function() {

		var currentScroll = $( this ).scrollLeft();
		var maxScroll = $( '.input-dvd-off-canvas-customizer-inner-music-options-inner' )[ 0 ].scrollWidth - $( '.input-dvd-off-canvas-customizer-inner-music-options-inner' )[ 0 ].clientWidth;

		if( currentScroll < maxScroll ) {

			$( '.dvd-customize-scroll-music' ).show();

		} else {

			$( '.dvd-customize-scroll-music' ).hide();

		}

		if( currentScroll > 0 ) {

			$( '.input-dvd-off-canvas-customizer-inner-music-options' ).addClass( 'show-before' );
			$( '.scroll-previous-music' ).removeClass( 'hidden' );

		} else {

			$( '.input-dvd-off-canvas-customizer-inner-music-options' ).removeClass( 'show-before' );
			$( '.scroll-previous-music' ).addClass( 'hidden' );

		}

	});


})();
